import React from 'react'
import DmtCommSche from '../../../components/dmtModule/dmtCommSche/DmtCommSche'

function DmtCommiosionSche() {
  return (
    <div><DmtCommSche/></div>
  )
}

export default DmtCommiosionSche